module.exports = __webpack_public_path__ + "img/메인우측배너.0d471f7c.png";